import { Space, Table } from "antd";
import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { UseMutateAsyncFunction, useMutation } from "react-query";
import { getSingleCurencyRate } from "../../api/exchangerate";
import { AxiosResponse } from "axios";
import { format } from "date-fns";
interface Props {
  isCurencyRateLoading: boolean;
  selectedCurrency: string | undefined;
  selectedDate: any;
  setPage: any;
  CurencyRateMutation: UseMutateAsyncFunction<
    AxiosResponse<any, any>,
    unknown,
    {
      limit: number;
    },
    unknown
  >;
  page: number;
  setPaginatedCurencyRate: any;
  paginatedCurencyRate: any;
}
const ExchangeList = ({
  isCurencyRateLoading,
  selectedCurrency,
  selectedDate,
  CurencyRateMutation,
  paginatedCurencyRate,
  page,
  setPaginatedCurencyRate,
  setPage,
}: Props) => {
  const { t } = useTranslation("common");

  const [prevPage, setPrevPage] = useState<number>(0);
  const [maxPage, setMaxPage] = useState<number>(0);

  useEffect(() => {
    page > prevPage &&
      maxPage < page &&
      CurencyRateMutation({
        limit: page * 10 + 10,
      }).then((res) => {
        if (page > maxPage) setMaxPage(page);
        setPaginatedCurencyRate(res.data?.data);
      });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [page]);

  const [formatedCurrRate, setFormatedCurrRate] = useState<any>();

  const { mutateAsync: getCurrencyMutation } = useMutation("curr", () =>
    getSingleCurencyRate(selectedCurrency)
  );

  useEffect(() => {
    setFormatedCurrRate(
      paginatedCurencyRate
        ?.map((cr: any) => {
          return {
            currency: cr?.curr?.name,
            rate: cr?.cuRate[0]?.rateText,
            timestamp: cr?.cuRate[0]?.timestamp,
          };
        })
        .filter(
          (curr: any) =>
            !selectedDate ||
            new Date(curr.timestamp * 1000).toDateString() ===
              selectedDate.toDateString()
        )
    );
  }, [paginatedCurencyRate, selectedDate]);
  useEffect(() => {
    selectedCurrency &&
      getCurrencyMutation().then((res) => {
        const arr = [];
        for (let i = 0; i < res.data.cuRate.length; i++) {
          arr.push({
            currency: res.data?.curr?.name,
            rate: res.data?.cuRate[i]?.rateText,
            timestamp: res.data?.cuRate[i]?.timestamp,
          });
        }
        setFormatedCurrRate(
          arr.filter(
            (curr: any) =>
              !selectedDate ||
              new Date(curr.timestamp * 1000).toDateString() ===
                selectedDate.toDateString()
          )
        );
      });
    !selectedCurrency &&
      setFormatedCurrRate(
        paginatedCurencyRate
          ?.map((cr: any) => {
            return {
              currency: cr?.curr?.name,
              rate: cr?.cuRate[0]?.rateText,
              timestamp: cr?.cuRate[0]?.timestamp,
            };
          })
          .filter(
            (curr: any) =>
              !selectedDate ||
              new Date(curr.timestamp * 1000).toDateString() ===
                selectedDate.toDateString()
          )
      );
  }, [
    paginatedCurencyRate,
    getCurrencyMutation,
    selectedCurrency,
    selectedDate,
  ]);

  const columns = [
    {
      title: `${t("currency")}`,
      dataIndex: "currency",
      key: "currency",
      className: "table-header",
    },
    {
      title: `${t("rate")}`,
      dataIndex: "rate",
      key: "rate",
      width: "13rem",
    },
    {
      title: `${t("date")}`,
      dataIndex: "timestamp",
      key: "timestamp",
      width: "13rem",
      render: (date: any) => {
        return format(new Date(date), "MM/dd/yyyy HH:mm");
      },
    },
  ];

  return (
    <Table
      scroll={{ x: 1000 }}
      loading={isCurencyRateLoading}
      dataSource={formatedCurrRate}
      columns={columns}
      rowClassName={(record, index) =>
        index % 2 === 0
          ? "table-row-light table-row"
          : "table-row-dark table-row"
      }
      onChange={(selectedPage) => {
        setPrevPage(page);
        setPage(selectedPage?.current ?? 1);
      }}
      rowKey={(record) => record.id}
      pagination={{ pageSize: 10 }}
    />
  );
};

export default ExchangeList;
